// 微信/小程序兼容路由/事件
import { platformNavigate } from '.'
import getQuery from './getQuery'
import { history } from './history'

const { userAgent } = window.navigator
const lowerUA = userAgent.toLowerCase()

// 是否微信小程序
export const isMiniProgram = lowerUA.includes('miniprogram')

// 是否微信环境
export const isWxEnv = lowerUA.includes('micromessenger') && !isMiniProgram

// 是否iOS
export const isIOS = /iphone|ipad|ipod/i.test(lowerUA)

// 是否安卓
export const isAndroid = lowerUA.includes('android')

// ready
export const wxReady = (fn: unknown) => {
  if (typeof fn === 'function') {
    window.wx && window.wx?.ready(fn)
  }
}

export function jsonToUrlParams(json) {
  if (!json) {
    return ''
  }
  return Object.keys(json)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(json[key]))
    .join('&')
}

/** 生成webviewurl */
export const createWebviewUrl = ({
  pageType = 'h5',
  path,
  param
}: {
  pageType?: string
  path: string
  param?: {
    [x: string]: string | number
  }
}) => {
  const tempParamStr = encodeURIComponent(path.split('?')?.[1] || '')
  const paramStr = tempParamStr || (param ? encodeURIComponent(jsonToUrlParams(param)) : '')

  return `/pages/WebViewUrl/index?pageType=${pageType}&path=${path}${
    paramStr ? `&param=${paramStr}` : ''
  }`
}

// export const miniProgram = window.wx?.miniProgram

interface NavProps {
  url?: string
  type?: string
  [key: string]: any
}

export const historyPush = (url: string) => {
  const pathPrefix = __ROUTE_PREFIX__ !== '/' ? __ROUTE_PREFIX__.slice(0, -1) : ''
  history.push(`${pathPrefix}${url}`)
}
/** 通用导航 */
export const commonNav = (() => {
  // 保留全局跳转
  // if (isMiniProgram) {
  //   return {
  //     navigateTo: ({ url = '', ...rest } = {}) => {
  //       navigateTo({
  //         url: createWebviewUrl({
  //           path: url
  //         }),
  //         ...rest
  //       })
  //     }
  //   }
  // }

  const pathPrefix = __ROUTE_PREFIX__ !== '/' ? __ROUTE_PREFIX__.slice(0, -1) : ''
  return {
    historyPush: (url: string) => {
      history.push(`${pathPrefix}${url}`)
    },
    navigateTo: ({ type = 'h5', url }: NavProps = {} as any) => {
      console.log('navigateTo', isMiniProgram, type, url)
      if (platformNavigate(url || '')) {
        history.push(`${pathPrefix}${url}`)
      }
    },
    redirectTo: ({ type = 'h5', url }: NavProps = {} as any) => {
      if (isMiniProgram && type === 'miniProgram') {
        return window.wx?.miniProgram?.redirectTo({ url })
      } else {
        history.replace(`${pathPrefix}${url}`)
      }
    },
    navigateBack: ({ type = 'h5' }: NavProps = {} as any) => {
      const isWxBack = getQuery('refer') === 'wx'
      if (isMiniProgram && (type === 'miniProgram' || isWxBack)) {
        return window.wx?.miniProgram?.navigateBack()
      } else {
        // 检查是否有历史记录
        if (window?.history?.length <= 1) {
          // 如果没有历史记录，则跳转到首页
          history.replace('/')
        } else {
          // 否则执行后退操作
          history.back()
        }
      }
    },
    switchTab: ({ type = 'h5', url }: NavProps = {} as any) => {
      if (isMiniProgram && type === 'miniProgram') {
        return window.wx?.miniProgram?.switchTab({ url })
      } else {
        history.replace('/')
      }
    },
    reLaunch: ({ type = 'h5', url }: NavProps = {} as any) => {
      if (isMiniProgram && type === 'miniProgram') {
        // eslint-disable-next-line no-unsafe-optional-chaining
        return window.wx?.miniProgram?.reLaunch({ url })
      } else {
        history.replace('/')
      }
    }
  }
})()
